module.exports = __webpack_public_path__ + "static/media/close-dk.323b7e3b.svg";